"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTransformedEventsSortToJSON = exports.GetTransformedEventsSortFromJSONTyped = exports.GetTransformedEventsSortFromJSON = exports.GetTransformedEventsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetTransformedEventsSort;
(function (GetTransformedEventsSort) {
    GetTransformedEventsSort["CREATEDAT"] = "CREATED_AT";
    GetTransformedEventsSort["EVENTTYPEID"] = "EVENT_TYPE_ID";
})(GetTransformedEventsSort = exports.GetTransformedEventsSort || (exports.GetTransformedEventsSort = {}));
function GetTransformedEventsSortFromJSON(json) {
    return GetTransformedEventsSortFromJSONTyped(json, false);
}
exports.GetTransformedEventsSortFromJSON = GetTransformedEventsSortFromJSON;
function GetTransformedEventsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetTransformedEventsSortFromJSONTyped = GetTransformedEventsSortFromJSONTyped;
function GetTransformedEventsSortToJSON(value) {
    return value;
}
exports.GetTransformedEventsSortToJSON = GetTransformedEventsSortToJSON;
